import { useEffect, useState } from 'react';

/**
 * Returns true after the component has mounted on the client. Use to gate
 * UI that depends on browser-only state (localStorage, navigator) so the
 * SSR-prerendered HTML matches the initial client render and avoids
 * hydration mismatch warnings.
 */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted;
}
